module.exports = __webpack_public_path__ + "img/advisory3.1a9eaf6f.svg";